package com.anjuros.website.templates.template10.util


object Template10Constants {

    const val FONT_FAMILY = "Manrope"
    const val HEADING_FONT_FAMILY = "Shippori Mincho"
    const val FALLBACK_FONT = "Roboto"
    const val GOOGLE_FONTS_URL =
        "https://fonts.googleapis.com/css2?family=Shippori+Mincho:wght@500;700;800&family=Manrope:wght@400;500;600;700&display=swap"

    const val CLIENTS_COMPANY = "Tai Chi Classes"
    const val CLIENTS_NAME = "TaiChi Ltd"
    const val CLIENTS_EMAIL = "taichi@gmail.com"
    const val CLIENTS_PHONE = "07534 444222"
    const val CLIENTS_COMPANY_NUMBER = "Company number: 1234567"
    const val CLIENTS_COMPANY_ADDRESS = "42 Greengate, Stafford ST16 2JA"
    const val CLASS_PRICE = "£10"
    const val EXPERIENCE = "20+"

    val CLASS_CITY1 = Pair("Stafford", "42 Greengate, ST16 2JA")
    val CLASS_CITY2 = Pair("Hixon", "High Street, ST18 0QF")
    val CLASS_CITY3 = Pair("Cannock", "High Street, WS11 1LH")

    // featured video first, then the three smaller ones
    val VIDEOS = listOf(
        "pNYHVe7nC3I",
        "NsZaY-EMpiA",
        "cEOS2zoyQw4",
        "7McCi0z7FU8",
    )
}

/** Decorative Chinese characters used across the design (not translated). */
object Template10Glyphs {
    const val LOGO = "太"
    const val HERO_SIDE = "太極拳"
    const val QI = "氣"
    const val MOTTO = "動中求静"
    const val BENEFITS = "益"
    const val MASTER = "師父"
    const val WAY = "道"
    const val WELCOME = "歡迎"
    const val LETTER = "書信"
    val NUMBERS = listOf("一", "二", "三")
}

object Template10Res {
    object Image {
        const val hero_video = "template10_hero_video.mp4"
        const val about = "template10_about.jpg"
    }
}
